import { regex } from "../../utils/regexValidation";

const {
  email,
  mobileRegex,
  passwordRegex,
  facebookLinkRegex,
  instagramLinkRegex,
  twitterLinkRegex,
} = regex;

export const updateProfile = {
  //Update Profile Schema

  updateProfileSchema: {
    fullName: {
      required: true,
      message: "Please provide name.",
    },
    email: {
      required: true,
      message: "Please provide email.",
      validate: (value, inputData = {}) => {
        return value.match(email);
      },
      invalidMessage: "Invalid email.",
      extraMessage: true,
    },
    number: {
      required: true,
      message: "Please provide phone number.",
      validate: (value, inputData = {}) => {
        return value.match(mobileRegex);
      },
      invalidMessage: "Invalid phone number.",
      extraMessage: true,
    },
    dateOfBirth: {
      required: true,
      message: "Please provide your date of birth.",
    },
    gender: {
      required: true,
      message: "Please select your gender.",
    },
    city: {
      required: true,
      message: "Please provide your city.",
    },
    state: {
      required: true,
      message: "Please provide your state.",
    },
    country: {
      required: true,
      message: "Please provide your country.",
    },
    nickname: {
      required: false,
      message: "Please provide your nickname.",
    },
    profession: {
      required: false,
      message: "Please provide your profession.",
    },
    whatsappNumber: {
      required: true,
      message: "Please provide number",
      validate: (value, inputData = {}) => {
        return value.match(mobileRegex);
      },
      invalidMessage: "Invalid number",
      extraMessage: true,
    },
    // facebook: {
    //   required: false,
    //   message: "",
    //   validate: (value, inputData = {}) => {
    //     return value ? value.match(facebookLinkRegex) : false;
    //   },
    //   invalidMessage: "Invalid facebook link.",
    //   extraMessage: true,
    // },
    // instagram: {
    //   required: false,
    //   message: "",
    //   validate: (value, inputData = {}) => {
    //     console.log(value,"Value");
    //     return value ? value.match(instagramLinkRegex) : false;
    //   },
    //   invalidMessage: "Invalid instagram link.",
    //   extraMessage: true,
    // },
    // x: {
    //   required: false,
    //   message: "",
    //   validate: (value, inputData = {}) => {
    //     return value ? value.match(twitterLinkRegex) : false;
    //   },
    //   invalidMessage: "Invalid X link.",
    //   extraMessage: true,
    // },
  },
};
